import { UserType } from "@core/enums/user-type";
import { PhoneNumber } from "@core/models/phone-number.model";
import { Country } from "@models/country.model";

import { UserExtended } from "./user-extended.model";

export class PrivateUser implements UserExtended {
  accountManagerId = "";
  address = "";
  city = "";
  countryId = "";
  country = new Country();
  dateOfBirth = "";
  dateOfDeath = "";
  email = "";
  firstLetters = "";
  firstName = "";
  gender = -1;
  homeNumber = -1;
  homeNumberAddition = "";
  id = "";
  identificationNumber = "";
  identificationType = 0;
  identificationValidUntil = "";
  incomeInNetherlands = false;
  lastName = "";
  lastNamePrefix = "";
  nationalityId = "";
  nationality = new Country();
  phoneNumbers = new Array<PhoneNumber>();
  relationNumber = "";
  socialSecurityNumber = "";
  street = "";
  taxInNetherlands = false;
  userName = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";
  zipCode = "";
  userType = UserType.private;

  constructor(dto?: PrivateUser) {
    if (!dto) {
      return;
    }
    this.accountManagerId = dto.accountManagerId;
    this.address = dto.address;
    this.city = dto.city;
    this.countryId = dto.countryId;
    this.country = dto.country;
    this.dateOfBirth = dto.dateOfBirth;
    this.dateOfDeath = dto.dateOfDeath;
    this.email = dto.email;
    this.firstLetters = dto.firstLetters;
    this.firstName = dto.firstName;
    this.gender = dto.gender;
    this.homeNumber = dto.homeNumber;
    this.homeNumberAddition = dto.homeNumberAddition;
    this.id = dto.id;
    this.identificationNumber = dto.identificationNumber;
    this.identificationType = dto.identificationType;
    this.identificationValidUntil = dto.identificationValidUntil;
    this.incomeInNetherlands = dto.incomeInNetherlands;
    this.lastName = dto.lastName;
    this.lastNamePrefix = dto.lastNamePrefix;
    this.nationalityId = dto.nationalityId;
    this.nationality = dto.nationality;
    this.phoneNumbers = dto.phoneNumbers;
    this.relationNumber = dto.relationNumber;
    this.socialSecurityNumber = dto.socialSecurityNumber;
    this.street = dto.street;
    this.taxInNetherlands = dto.taxInNetherlands;
    this.userName = dto.userName;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
    this.zipCode = dto.zipCode;
    this.userType = dto.userType;
  }
}
